<ion-header>
	<app-account-toolbar src="/assets/icons-menu-modal/agb.svg" title="menu_popover.terms" (back)="goBack()"></app-account-toolbar>
</ion-header>

<ion-content class="ion-padding">
	<h2>1. Vertragspartner und Vertragsleistungen</h2>
	<p align="justify" style="margin-bottom: 0.11in">
		(1) Du kannst über unseren Webstore bei teilnehmenden Restaurants unserer Franchisenehmer Speisen, Getränke und ggf. weitere
		Leistungen bestellen („Bestellservice“). Für die Bereitstellung des Bestellservice sind wir verantwortlich:
	</p>
	<p style="margin-left: 0.49in; margin-bottom: 0in">dean&amp;david Franchise GmbH</p>
	<p style="margin-left: 0.49in; margin-bottom: 0in">Lohenstraße 8</p>
	<p style="margin-left: 0.49in; margin-bottom: 0in">82166 Gräfelfing</p>
	<p style="margin-left: 0.49in; margin-bottom: 0in">Deutschland&nbsp;</p>
	<p style="margin-left: 0.49in; margin-bottom: 0in">Tel.: +49 89 26 20 59 410</p>
	<p style="margin-left: 0.49in; margin-bottom: 0in">E-Mail: info&#64;deananddavid.com</p>
	<p align="justify" style="margin-bottom: 0.11in">
		<br />
		<br />
	</p>
	<p align="justify" style="margin-bottom: 0.11in">
		Für die Abwicklung des Bestellservices auf unserer Internetseite
		<a href="https://order.deananddavid.com/home" target="_blank" role="link">https://order.deananddavid.com/home</a>
		setzen wir die Sterlix GmbH, Christstraße 38,14059 Berlin („Sterlix“) ein.
	</p>
	<p align="justify" style="margin-bottom: 0.11in">
		(2) Die nachfolgenden Bedingungen gelten gleichlautend für die Verwendung des Bestellservice bei allen unseren Franchisenehmern. Die
		von Dir im Webstore bestellten Leistungen werden von unseren Franchisenehmern und nicht von uns selbst erbracht. Wenn Du eine
		Bestellung aufgrund der vorliegenden Bedingungen vornimmst, ist daher ausschließlich derjenige Franchisenehmer Dein Vertragspartner,
		der das Restaurant betreibt, bei dem Du Deine Bestellung aufgegeben hast.
	</p>
	<p align="justify" style="margin-bottom: 0.11in">
		(3) Wir haben keinen Einfluss darauf, welche Restaurants am Bestellservice teilnehmen und versprechen nicht, dass in einem
		bestimmten Restaurant die Nutzung des Services möglich ist.
	</p>
	<p align="justify" style="margin-bottom: 0.11in">
		<br />
		<br />
	</p>
	<h2>2. Anmeldung, Registrierung und Benutzerkonto</h2>
	<p style="margin-bottom: 0.11in">
		(1) Du kannst Bestellungen im Webstore ohne Anmeldung als Gast aufgeben oder Dich mit einem der folgenden Konten anmelden:
	</p>
	<ul>
		<li><p style="margin-bottom: 0.11in">dean&amp;david</p></li>
		<li><p style="margin-bottom: 0.11in">Apple</p></li>
		<li><p style="margin-bottom: 0.11in">Facebook</p></li>
		<li><p style="margin-bottom: 0.11in">Google</p></li>
	</ul>
	<p align="justify" style="margin-bottom: 0.11in">
		(2) Wenn Du Dich über dean&amp;david anmelden möchtest, aber noch kein dean&amp;david Konto hast, musst Du Dich einmal registrieren
		und ein Benutzerkonto eröffnen.
	</p>
	<p style="margin-bottom: 0.11in">(3) Bei der Registrierung benötigen wir folgende persönliche Angaben von Dir:</p>
	<ul>
		<li><p style="margin-bottom: 0.11in">Vor- und Nachname</p></li>
		<li><p style="margin-bottom: 0.11in">E-Mail-Adresse</p></li>
		<li><p style="margin-bottom: 0.11in">Geburtsdatum (optional)</p></li>
		<li><p style="margin-bottom: 0.11in">Telefonnummer (optional)</p></li>
	</ul>
	<p align="justify" style="margin-bottom: 0.11in">
		(4) Du bist dazu verpflichtet, wahrheitsgemäße Angaben zu machen und diese bei Änderungen unverzüglich anzupassen. Wir übernehmen
		keine Haftung für die Folgen falscher Angaben.
	</p>
	<p style="margin-bottom: 0.11in">(5) Unzulässig ist insbesondere das Anlegen eines Benutzerkontos, das</p>
	<ul>
		<li><p style="margin-bottom: 0.11in">nicht einer real existierenden natürlichen Person zugeordnet werden kann,</p></li>
		<li><p style="margin-bottom: 0.11in">im Namen einer fremden Person ohne ihr Einverständnis erstellt worden ist oder</p></li>
		<li><p style="margin-bottom: 0.11in">automatisiert durch einen Algorithmus erstellt worden ist.</p></li>
	</ul>
	<p align="justify" style="margin-bottom: 0.11in">
		(6) Um Deine Registrierung abzuschließen, musst Du noch ein Passwort auswählen und Dich mit diesen Nutzungsbedingungen einverstanden
		erklären.
	</p>
	<p align="justify" style="margin-bottom: 0.11in">
		(7) Nach erfolgreicher Registrierung erhältst Du von uns eine E-Mail-Bestätigung und Dein persönliches Benutzerkonto. Du kannst kein
		weiteres Konto bei uns haben.
	</p>
	<p align="justify" style="margin-bottom: 0.11in">
		(8) Du bist für alle Aktivitäten auf Deinem Benutzerkonto verantwortlich. Du darfst Dein Konto weder vorübergehend noch dauerhaft
		Dritten zur Verfügung stellen. Du musst Dein Konto vor unberechtigten Zugriffen schützen und uns umgehend mitteilen, wenn Du
		derartige Zugriffsversuche bemerkst.
	</p>
	<p style="margin-bottom: 0.11in">
		<br />
		<br />
	</p>
	<h2>3. Löschung und Sperrung Deines Benutzerkontos</h2>
	<p style="margin-bottom: 0.11in">(1) Du kannst Dein Benutzerkonto jederzeit löschen.</p>
	<p style="margin-bottom: 0.11in">
		(2) Wenn Du Dein Benutzerkonto länger als zwei Jahre nicht verwendest, behalten wir uns vor, es zu löschen.
	</p>
	<p style="margin-bottom: 0.11in">
		(3) Solltest Du gegen diese Nutzungsbedingungen verstoßen, behalten wir uns vor, Dein Benutzerkonto vorübergehend zu sperren und
		ggf. endgültig zu löschen.
	</p>
	<p style="margin-bottom: 0.11in">(4) Wir werden eine solche Maßnahme vorher ankündigen und Dir Gelegenheit zur Stellungnahme geben.</p>
	<p style="margin-bottom: 0.11in">
		<br />
		<br />
	</p>
	<h2>4. Zustandekommen des Kaufvertrags</h2>
	<p align="justify" style="line-height: 0.22in; margin-top: 0.08in; margin-bottom: 0.08in">
		(1) Der Franchisenehmer des von Dir ausgewählten Restaurants macht Dir ein rechtlich verbindliches Angebot über die im Webstore als
		verfügbar angezeigten Speisen, Getränke und weiteren Leistungen („Artikel“).
	</p>
	<p align="justify" style="line-height: 0.22in; margin-top: 0.08in; margin-bottom: 0.08in">
		(2) Ein Vertrag zwischen Dir und dem Franchisenehmer über die in Deinem Warenkorb befindlichen Artikel kommt zustande, wenn Du im
		letzten Schritt des Bestellvorgangs den Button „Zahlungspflichtig bestellen“ betätigst.
	</p>
	<p align="justify" style="line-height: 0.22in; margin-top: 0.08in; margin-bottom: 0.08in">
		(3) Die für den Vertragsschluss zur Verfügung stehende Sprache ist ausschließlich Deutsch. Übersetzungen dieser Nutzungsbedingungen
		in andere Sprachen dienen lediglich zu Deiner Information. Bei etwaigen Unterschieden zwischen den Sprachfassungen hat der deutsche
		Text Vorrang.
	</p>
	<p style="margin-bottom: 0.11in">
		<br />
		<br />
	</p>
	<h2>5. Bestellvorgang</h2>
	<p align="justify" style="line-height: 0.22in; margin-top: 0.08in; margin-bottom: 0.08in">
		(1) Das Bestellmenü öffnet sich, indem Du auf unserer Homepage den Button „Jetzt bestellen&quot; betätigst. Du kannst dann zunächst
		eine Bewirtungsoption („Im Restaurant“, „Vorbestellung to go“, „Vorbestellung Lieferdienst“ oder „Foodspot“) auswählen und
		anschließend das Restaurant, bei dem Du bestellen möchtest.
	</p>
	<p align="justify" style="line-height: 0.22in; margin-top: 0.08in; margin-bottom: 0.08in">
		(2) Im nächsten Schritt werden Dir die im Restaurant verfügbaren Artikel und ihr Preis angezeigt. Durch Anklicken kannst Du die von
		Dir gewünschten Artikel, eventuelle Ergänzungen und die gewünschte Menge bestimmen. Durch Anklicken des Buttons „Zum Warenkorb
		hinzufügen&quot; wird der ausgewählte Artikel in Deinen Warenkorb gelegt. Du kannst Dir den Warenkorb jederzeit ansehen und dort
		hineingelegte Artikel ändern oder löschen.
	</p>
	<p align="justify" style="line-height: 0.22in; margin-top: 0.08in; margin-bottom: 0.08in">
		(3) Wenn Du mit Deiner Auswahl zufrieden bist, betätigst Du den Button „Bestellung abschließen“. Solltest Du Dich zuvor noch nicht
		angemeldet haben, musst Du dies jetzt tun oder als Gast fortfahren. Du gelangst nun zur Bestellübersicht, in der Dir u.a. Deine
		Artikelauswahl, das ausgewählte Restaurant und der Gesamtpreis angezeigt werden. Eventuell benötigen wir noch weitere für den
		Vertragsabschluss notwendige Kontaktinformationen von Dir sowie den gewünschten Abholzeitpunkt. Nach Anklicken des Buttons „Zur
		Bestellübersicht“ werden Dir alle Details Deiner Bestellung noch einmal angezeigt.
	</p>
	<p align="justify" style="line-height: 0.22in; margin-top: 0.08in; margin-bottom: 0.08in">
		(4) Du musst schließlich noch eine Zahlungsmethode auswählen. Dir stehen regelmäßig folgende Optionen zur Verfügung – vorausgesetzt,
		das ausgewählte Restaurant unterstützt sie und Du unterhältst bei dem jeweiligen Zahlungsdienstleister ein entsprechendes Konto:
	</p>
	<ul>
		<li><p align="justify" style="line-height: 0.22in; margin-top: 0.08in; margin-bottom: 0.08in">Apple Pay</p></li>
		<li><p align="justify" style="line-height: 0.22in; margin-top: 0.08in; margin-bottom: 0.08in">Google Pay</p></li>
		<li><p align="justify" style="line-height: 0.22in; margin-top: 0.08in; margin-bottom: 0.08in">Maestro</p></li>
		<li><p align="justify" style="line-height: 0.22in; margin-top: 0.08in; margin-bottom: 0.08in">Master Card</p></li>
		<li><p align="justify" style="line-height: 0.22in; margin-top: 0.08in; margin-bottom: 0.08in">PayPal</p></li>
		<li><p align="justify" style="line-height: 0.22in; margin-top: 0.08in; margin-bottom: 0.08in">VISA</p></li>
	</ul>
	<p style="margin-bottom: 0.11in">
		(5) Nach Auswahl der Zahlungsmethode und ggf. Abwicklung der notwendigen Schritte auf der Seite des Zahlungsdienstleisters schließt
		Du durch Betätigen des Buttons „Zahlungspflichtig bestellen“ mit dem Franchisenehmer, der das von Dir ausgewählte Restaurant
		betreibt, einen verbindlichen Kaufvertrag über die von Dir ausgewählten Artikel ab.
	</p>
	<p style="margin-bottom: 0.11in">
		<br />
		<br />
	</p>
	<h2>6. Widerrufsrecht</h2>
	<p align="justify" style="margin-bottom: 0.11in">
		Du hast nach Vertragsabschluss kein Widerrufsrecht, weil es sich vorliegend um einen Vertrag zur Lieferung von Waren handelt, die
		nicht vorgefertigt und von Dir individuell ausgewählt worden sind.
	</p>
	<p style="margin-bottom: 0.11in">
		<br />
		<br />
	</p>
	<h2>7. Zahlungsbedingungen</h2>
	<p align="justify" style="line-height: 0.22in; margin-top: 0.08in; margin-bottom: 0.08in">
		(1) Sämtliche Preisangaben im Webstore sind Endpreise in Euro inklusive der gesetzlichen Umsatzsteuer.
	</p>
	<p align="justify" style="line-height: 0.22in; margin-top: 0.08in; margin-bottom: 0.08in">
		(2) Der Kaufpreis ist mit Abschluss der Bestellung sofort zur Zahlung fällig.
	</p>
	<p align="justify" style="line-height: 0.22in; margin-top: 0.08in; margin-bottom: 0.08in">
		<br />
		<br />
	</p>
	<h2>8. Datenschutz</h2>
	<p align="justify" style="line-height: 0.22in; margin-top: 0.08in; margin-bottom: 0.08in">
		Wir halten bei der Verarbeitung Deiner personenbezogenen Informationen die gesetzlichen Vorschriften zum Datenschutz ein. Dies
		beinhaltet auch dem aktuellen Stand der Technik angepasste technische Sicherheitsmaßnahmen (Art.&nbsp;32 DSGVO) und die
		Verpflichtung der Mitarbeiter auf das Datengeheimnis (Art.&nbsp;28 Abs.&nbsp;3 lit. b DSGVO). Weitere Informationen enthält unsere
		Datenschutzerklärung unter
		<u><a href="https://order.deananddavid.com/privacy" target="_blank" role="link">https://order.deananddavid.com/privacy</a></u
		>.
	</p>
	<p align="justify" style="line-height: 0.22in; margin-top: 0.08in; margin-bottom: 0.08in">
		<br />
		<br />
	</p>
	<h2>9. Schlussbestimmungen</h2>
	<p align="justify" style="line-height: 0.22in; margin-top: 0.08in; margin-bottom: 0.08in">
		(1) Es gilt deutsches Recht unter Ausschluss des UN-Kaufrechts. Wenn Du zum Zeitpunkt Deiner Bestellung Deinen gewöhnlichen
		Aufenthalt in einem anderen Land hast, bleibt die Anwendung zwingender Rechtsvorschriften dieses Landes von der in Satz&nbsp;1
		getroffenen Rechtswahl unberührt.
	</p>
	<p align="justify" style="line-height: 0.22in; margin-top: 0.08in; margin-bottom: 0.08in">
		(2) Wir sind verpflichtet, Dich als Verbraucher auf die Plattform zur Online-Streitbeilegung (OS-Plattform) der Europäischen
		Kommission hinzuweisen. Diese OS-Plattform ist überfolgenden Link erreichbar:
		<a href="http://ec.europa.eu/consumers/odr" target="_blank" role="link"> http://ec.europa.eu/consumers/odr</a>. Zur Teilnahme an
		einem Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle sind wir jedoch weder verpflichtet noch bereit.
	</p>
	<p align="justify" style="line-height: 0.22in; margin-top: 0.08in; margin-bottom: 0.08in">
		(3) Sollte eine der vorstehenden Bestimmungen unwirksam sein bzw. werden oder eine an sich notwendige Bestimmung nicht enthalten
		sein, wird dadurch die Wirksamkeit der übrigen Bestimmungen nicht berührt. Wir bemühen uns, in diesem Fall eine einvernehmliche
		Regelung zu finden.
	</p>
</ion-content>
